module.exports = __webpack_public_path__ + "img/markingAssignments2.ccd87616.png";